import styled from 'styled-components';

export const StayBlockInner = styled.div(
  props => `
    padding: ${props.theme.spacing.large.l30} ${props.theme.spacing.large.l30} 0 ${props.theme.spacing.large.l30};
    @media only screen and (min-width:320px) and (max-width: 767px){
      padding: ${props.theme.spacing.large.l30} 0;
    }
    @media only screen and (min-width:768px) and (max-width: 1024px){
      padding: ${props.theme.spacing.large.l30} 0;
    }
  `
);

export const StayBlockWrapper = styled.div(
  props => `
    padding: ${props.theme.spacing.small.s2};
  `
);

export const StayImageBlock = styled.img(
  props => `
    width: 20rem;
    height: 20rem;
  `
);

